import { render, staticRenderFns } from "./FollowupsListSummary.vue?vue&type=template&id=90634250&scoped=true"
import script from "./FollowupsListSummary.vue?vue&type=script&lang=js"
export * from "./FollowupsListSummary.vue?vue&type=script&lang=js"
import style0 from "./FollowupsListSummary.vue?vue&type=style&index=0&id=90634250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90634250",
  null
  
)

export default component.exports